module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/jump-to-c1f1f8bc9f963c1a4a3734756af8056b.svg";